import Swal from 'sweetalert2';
import $http from '../../../axios-instance';
import $http_ari from '../../../axios-instance-ari';
import $http_wor from '../../../axios-instance-wor';
import {obtenerDominioAnalisisRiesgos} from '../../../util/dominios';

/**
 * Obtener tasks.
 */
export async function fetchTasks({state, commit}, reset_page = false) {

    if (reset_page) {
        commit('resetPageParams');
    }

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('tasks/' + state.params.company_id, {params: state.params})
        .then(async (response) => {

            let tasks = response.data.data;

            let domain = obtenerDominioAnalisisRiesgos();

            domain = domain.replace('/api/v1', '');

            tasks.data.map(t => {
                t.url = null;

                if (t.image_name) {
                    t.url = domain + '/storage/tasks/tasks/' + state.params.company_id + '/' + t.image_name;
                }
            });

            commit('setTasks', tasks);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener task.
 */
export async function getTask({state, commit}, id) {

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('tasks/' + state.params.company_id + '/' + id,)
        .then(async (response) => {

            let task = response.data.data;

            let domain = obtenerDominioAnalisisRiesgos();

            domain = domain.replace('/api/v1', '');

            task.url = domain + '/storage/tasks/tasks/' + state.params.company_id + '/' + task.image_name;

            task.controls.map(tc => {
                tc.url = null;

                if (tc.image_name) {
                    tc.url = domain + '/storage/tasks/controls/' + state.params.company_id + '/' + tc.image_name;
                }
            });

            task.steps.map(ts => {
                ts.url = null;

                if (ts.image_name) {
                    ts.url = domain + '/storage/tasks/steps/' + state.params.company_id + '/' + ts.image_name;
                }
            });

            commit('setTask', task);

            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            console.error(error);
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener último task.
 */
export async function getLastTask({state, commit}) {

    commit('dashboard/load', true, {root: true});

    await $http_ari.get('tasks/last/' + state.params.company_id)
        .then(async (response) => {
            commit('setCodeToTask', response.data.data.code);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Crear task.
 */
export async function addTask({state, commit, dispatch}, company_id = null) {

    let form_data = new FormData();

    for (let key in state.task) {
        if (['name', 'description', 'image', 'slq_location_id'].includes(key)) {
            form_data.append(key, state.task[key]);
        }
    }

    let steps = [];

    state.task.steps.map((s, i) => {
        steps.push({
            id: s.id,
            order: s.order,
            name: s.name,
            description: s.description
        });

        form_data.append('steps_images[' + i + ']', s.image);
    });

    form_data.append('steps', JSON.stringify(steps));

    let controls = [];

    state.task.controls.map((s, i) => {
        controls.push({
            id: s.id,
            sys_list_type_id: s.sys_list_type_id,
            description: s.description
        });

        form_data.append('controls_images[' + i + ']', s.image);
    });

    state.task.positions.map((p, i) => {
        form_data.append('positions[' + i + ']', p);
    });

    form_data.append('controls', JSON.stringify(controls));
    form_data.append('company_id', state.params.company_id);

    commit('dashboard/load', true, {root: true});

    if (!!company_id) {
        state.params.company_id = company_id;
    }

    await $http_ari.post('tasks/' + state.params.company_id, form_data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});

            if (!company_id) {
                await dispatch('fetchTasks');
            }

            commit('setModalShow', false);
            commit('resetTask');

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });

        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Actualizar task.
 */
export async function updateTask({state, commit, dispatch}) {

    let form_data = new FormData();

    for (let key in state.task) {
        if (['name', 'description', 'image', 'slq_location_id'].includes(key)) {
            form_data.append(key, state.task[key]);
        }
    }

    let steps = [];

    state.task.steps.map((s, i) => {
        steps.push({
            id: s.id,
            order: s.order,
            name: s.name,
            description: s.description
        });

        form_data.append('steps_images[' + i + ']', s.image);
    });

    form_data.append('steps', JSON.stringify(steps));

    let controls = [];

    state.task.controls.map((s, i) => {
        controls.push({
            id: s.id,
            sys_list_type_id: s.sys_list_type_id,
            description: s.description
        });

        form_data.append('controls_images[' + i + ']', s.image);
    });

    state.task.positions.map((p, i) => {
        form_data.append('positions[' + i + ']', p);
    });

    form_data.append('controls', JSON.stringify(controls));
    form_data.append('company_id', state.params.company_id);
    form_data.append('_method', 'PUT');

    commit('dashboard/load', true, {root: true});

    await $http_ari.post('tasks/' + state.params.company_id + '/' + state.task.id, form_data)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            await dispatch('fetchTasks');
            commit('setModalShow', false);

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
        }).catch(async error => {
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: error.message,
                showConfirmButton: false,
                timer: 2000
            });

        });
}

/**
 * Eliminar Task.
 */
export async function deleteTask({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Eliminar',
        text: '¿Está seguro de eliminar este Task?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, eliminar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http_ari.delete('tasks/' + state.params.company_id + '/' + id)
                .then(async (response) => {

                    await dispatch('fetchTasks');
                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 2000
                    });


                }).catch((error) => {

                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error.message,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}


/**
 * Obtener empresas.
 */
export async function fetchCompanies({commit, state, rootState}, filter) {

    if (!rootState.dashboard.loading && filter && filter.length > 2) {
        commit('dashboard/load', true, {root: true});

        let params = {
            nombre: filter
        };

        await $http.get('/empresas/lista', {params})
            .then((response) => {
                commit('setCompanies', response.data.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch(() => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener tipos de Task.
 */
export async function fetchTypes({commit, state, rootState}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('/lists/TCOAR')
        .then((response) => {
            commit('setTypes', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Descargar plantilla
 */
export async function downloadImage({commit, state}) {

    commit('dashboard/load', true, {root: true});

    await $http_ari({
        url: '/tasks/download-image/' + state.params.company_id + '/' + state.modal_image.data.id,
        method: 'GET',
        responseType: 'blob',
        params: {company_id: state.params.company_id}
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', state.modal_image.data.original_image_name);
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}

/**
 * Obtener cargos.
 */
export async function fetchPositions({state, commit}) {

    let params = {
        paginate: 0
    };

    commit('dashboard/load', true, {root: true});

    await $http_wor.get('positions/' + state.params.company_id, {params})
        .then(async (response) => {
            commit('setPositions', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * ObtenerUbicaciones
 */
export async function getLocations({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http
        .get('/company/location/tree/' + state.params.company_id)
        .then(response => {
            commit('setLocations', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Descargar tarea.
 */
export async function downloadTask({commit, state}, task) {

    commit('dashboard/load', true, {root: true});

    await $http_ari({
        url: 'tarea/descargar/' + task.id + '/' + state.params.company_id,
        method: 'GET',
        responseType: 'blob'
    })
        .then(response => {
            commit('dashboard/load', false, {root: true});
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', task.name + '.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            commit('dashboard/load', false, {root: true});
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 3000,
                customClass: 'notification-box'
            });
        });
}
